import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import Products from 'merchandise-lib/constants/Product';
import * as links from '../core/utilities/links';
import * as UpgradeProducts from './UpgradeProducts';
const {
  SALES_PRO,
  SALES_FREE,
  SALES_STARTER,
  SALES_PROFESSIONAL,
  SALES_ENTERPRISE,
  SALES_STARTER_USER,
  SALES_PROFESSIONAL_USER,
  SALES_ENTERPRISE_USER,
  MARKETING_FREE,
  MARKETING_STARTER,
  MARKETING_STARTER_EMAIL,
  MARKETING_BASIC,
  MARKETING_PRO,
  MARKETING_ENTERPRISE,
  SERVICE_FREE,
  SERVICE_STARTER,
  SERVICE_PROFESSIONAL,
  SERVICE_ENTERPRISE,
  SERVICE_STARTER_USER,
  SERVICE_PROFESSIONAL_USER,
  SERVICE_ENTERPRISE_USER,
  STARTER_CONTACTS,
  BASIC_CONTACTS,
  MARKETING_STARTER_CONTACTS,
  MARKETING_PROFESSIONAL_CONTACTS,
  MARKETING_ENTERPRISE_CONTACTS,
  ADS,
  ADS_CAPACITY,
  WEBSITE,
  REPORTING,
  DEDICATED_IP,
  TRANSACTIONAL_EMAIL,
  ADDITIONAL_ACCOUNT,
  BRAND_DOMAIN,
  WORKFLOWS_ADDON,
  LISTS_ADDON,
  ESIGNATURE_LIMIT_INCREASE,
  DOMAINS_LIMIT_INCREASE,
  DESIGNATED_TECHNICAL_SUPPORT,
  IN_PERSON_TRAINING,
  STARTER_KIT,
  SALES_PROFESSIONAL_ONBOARDING,
  SERVICE_PROFESSIONAL_ONBOARDING,
  INBOUND_CONSULTING_BLOCK,
  TECHNICAL_CONSULTING_BLOCK,
  CRM,
  CMS_STARTER,
  CMS_PROFESSIONAL,
  CMS_ENTERPRISE,
  OPERATIONS_STARTER,
  OPERATIONS_PROFESSIONAL,
  OPERATIONS_ENTERPRISE,
  ENTERPRISE,
  PARTNER_PROGRAM,
  SUITE_STARTER,
  SUITE_PROFESSIONAL,
  SUITE_ENTERPRISE,
  BUNDLE,
  MARKETING,
  SALES,
  SERVICE,
  CUSTOM_SSL,
  SANDBOX_LIMIT_INCREASE,
  CALLING_LIMIT_INCREASE,
  PHONE_LIMIT_INCREASE,
  TEAMS_LIMIT_INCREASE,
  WHATSAPP_LIMIT_INCREASE,
  VIDEO_LIMIT_INCREASE,
  MARKETING_SMS_ADDON,
  MARKETING_SMS_SHORT_CODE,
  MARKETING_SMS_LIMIT_INCREASE,
  WORKFLOWS_LIMIT_INCREASE,
  USERS_LIMIT_INCREASE,
  CUSTOM_OBJECTS_LIMIT_INCREASE,
  CALCULATED_PROPERTIES_LIMIT_INCREASE,
  CORE_SEATS_STARTER,
  CORE_SEATS_PROFESSIONAL,
  CORE_SEATS_ENTERPRISE,
  CRM_OBJECT_LIMIT_INCREASE,
  CUSTOM_PROPERTIES_LIMIT_INCREASE,
  CRM_CONTACT_RECORDS_LIMIT_INCREASE,
  MARKETING_PLUS_PROFESSIONAL,
  MARKETING_PLUS_ENTERPRISE,
  BREEZE_INTELLIGENCE_CREDITS_100,
  BREEZE_INTELLIGENCE_CREDITS_1000,
  BREEZE_INTELLIGENCE_CREDITS_10000,
  BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED,
  BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED,
  BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED,
  BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_100,
  BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_1000,
  BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_10000,
  HUBSPOT_CREDITS_COMMITTED,
  HUBSPOT_CREDITS_COMMITTED_OVERAGE,
  HUBSPOT_CREDITS_OVERAGE,
  COMMERCE_PROFESSIONAL,
  COMMERCE_ENTERPRISE
} = UpgradeProducts;
const UpgradeProductProperties = {
  [SALES_PRO]: {
    upgradeLink: links.salesPricing
  },
  [SALES_FREE]: {
    upgradeLink: links.salesPricing
  },
  [SALES_STARTER]: {
    upgradeLink: links.salesPricing
  },
  [SALES_PROFESSIONAL]: {
    upgradeLink: links.salesPricing
  },
  [SALES_ENTERPRISE]: {
    upgradeLink: links.salesPricing
  },
  [SALES_STARTER_USER]: {
    upgradeLink: links.salesPricing
  },
  [SALES_PROFESSIONAL_USER]: {
    upgradeLink: links.salesPricing
  },
  [SALES_ENTERPRISE_USER]: {
    upgradeLink: links.salesPricing
  },
  [MARKETING_FREE]: {
    upgradeLink: links.marketingPricing
  },
  [MARKETING_STARTER]: {
    upgradeLink: links.marketingPricing
  },
  [MARKETING_STARTER_EMAIL]: {
    upgradeLink: links.marketingPricing
  },
  [MARKETING_BASIC]: {
    upgradeLink: links.marketingPricing
  },
  [MARKETING_PRO]: {
    upgradeLink: links.marketingPricing
  },
  [MARKETING_ENTERPRISE]: {
    upgradeLink: links.marketingPricing
  },
  [SERVICE_FREE]: {
    upgradeLink: links.servicePricing
  },
  [SERVICE_STARTER]: {
    upgradeLink: links.servicePricing
  },
  [SERVICE_PROFESSIONAL]: {
    upgradeLink: links.servicePricing
  },
  [SERVICE_ENTERPRISE]: {
    upgradeLink: links.servicePricing
  },
  [SERVICE_STARTER_USER]: {
    upgradeLink: links.servicePricing
  },
  [SERVICE_PROFESSIONAL_USER]: {
    upgradeLink: links.servicePricing
  },
  [SERVICE_ENTERPRISE_USER]: {
    upgradeLink: links.servicePricing
  },
  [BASIC_CONTACTS]: {
    upgradeLink: links.marketingPricing
  },
  [STARTER_CONTACTS]: {
    upgradeLink: links.starterContacts
  },
  [MARKETING_STARTER_CONTACTS]: {
    upgradeLink: links.marketingPricing
  },
  [MARKETING_PROFESSIONAL_CONTACTS]: {
    upgradeLink: links.marketingPricing
  },
  [MARKETING_ENTERPRISE_CONTACTS]: {
    upgradeLink: links.marketingPricing
  },
  [CMS_STARTER]: {
    upgradeLink: links.cmsPricing
  },
  [CMS_PROFESSIONAL]: {
    upgradeLink: links.cmsPricing
  },
  [CMS_ENTERPRISE]: {
    upgradeLink: links.cmsPricing
  },
  [OPERATIONS_STARTER]: {
    upgradeLink: links.operationsPricing
  },
  [OPERATIONS_PROFESSIONAL]: {
    upgradeLink: links.operationsPricing
  },
  [OPERATIONS_ENTERPRISE]: {
    upgradeLink: links.operationsPricing
  },
  [ADS]: {
    upgradeLink: links.addonAds
  },
  [ADS_CAPACITY]: {
    upgradeLink: links.addonAds
  },
  [WEBSITE]: {
    upgradeLink: links.addonWebsite
  },
  [REPORTING]: {
    upgradeLink: links.addonReporting
  },
  [DEDICATED_IP]: {
    upgradeLink: links.addonDedicatedIp
  },
  [TRANSACTIONAL_EMAIL]: {
    upgradeLink: links.addonTransactionalEmail
  },
  [ADDITIONAL_ACCOUNT]: {
    upgradeLink: links.addonAdditionalPortalLink
  },
  [BRAND_DOMAIN]: {
    upgradeLink: links.addonBrandDomain
  },
  [WORKFLOWS_ADDON]: {
    upgradeLink: links.marketingPricing
  },
  [MARKETING_SMS_ADDON]: {
    upgradeLink: links.addonMarketingSms
  },
  [MARKETING_SMS_SHORT_CODE]: {
    upgradeLink: links.addonMarketingSmsShortCode
  },
  [LISTS_ADDON]: {
    upgradeLink: links.marketingPricing
  },
  [ESIGNATURE_LIMIT_INCREASE]: {
    upgradeLink: links.salesPricing
  },
  [DOMAINS_LIMIT_INCREASE]: {
    upgradeLink: links.marketingPricing
  },
  [CUSTOM_SSL]: {
    upgradeLink: links.addonCustomSsl
  },
  [SANDBOX_LIMIT_INCREASE]: {
    upgradeLink: links.addonSandbox
  },
  [DESIGNATED_TECHNICAL_SUPPORT]: {
    upgradeLink: links.serviceDesignatedTechnicalSupport
  },
  [IN_PERSON_TRAINING]: {
    upgradeLink: links.serviceInPersonTraining
  },
  [STARTER_KIT]: {
    upgradeLink: links.serviceStarterKit
  },
  [SALES_PROFESSIONAL_ONBOARDING]: {
    upgradeLink: links.salesProfessionalOnboarding
  },
  [SERVICE_PROFESSIONAL_ONBOARDING]: {
    upgradeLink: links.serviceProfessionalOnboarding
  },
  [INBOUND_CONSULTING_BLOCK]: {
    upgradeLink: links.inboundConsultingBlock
  },
  [TECHNICAL_CONSULTING_BLOCK]: {
    upgradeLink: links.technicalConsultingBlock
  },
  [ENTERPRISE]: {
    upgradeLink: links.marketingPricing
  },
  [CRM]: {
    upgradeLink: links.addonCrm
  },
  [PARTNER_PROGRAM]: {
    upgradeLink: links.partnerProgramPaywall
  },
  [SUITE_STARTER]: {
    upgradeLink: links.suite
  },
  [SUITE_PROFESSIONAL]: {
    upgradeLink: links.suite
  },
  [SUITE_ENTERPRISE]: {
    upgradeLink: links.suite
  },
  [BUNDLE]: {
    upgradeLink: links.bundle
  },
  [MARKETING]: {
    upgradeLink: links.marketingPricing
  },
  [SALES]: {
    upgradeLink: links.salesPricing
  },
  [SERVICE]: {
    upgradeLink: links.servicePricing
  },
  [CALLING_LIMIT_INCREASE]: {
    upgradeLink: links.addonCalling
  },
  [PHONE_LIMIT_INCREASE]: {
    upgradeLink: links.addonPhone
  },
  [TEAMS_LIMIT_INCREASE]: {
    upgradeLink: links.addonTeams
  },
  [WHATSAPP_LIMIT_INCREASE]: {
    upgradeLink: links.addonWhatsapp
  },
  [MARKETING_SMS_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseMarketingSms
  },
  [VIDEO_LIMIT_INCREASE]: {
    upgradeLink: links.addonVideo
  },
  [WORKFLOWS_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseWorkflows
  },
  [USERS_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseUsers
  },
  [CUSTOM_OBJECTS_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseCustomObjects
  },
  [CALCULATED_PROPERTIES_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseCalculatedProperties
  },
  [CUSTOM_PROPERTIES_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseCustomProperties
  },
  [CRM_CONTACT_RECORDS_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseCRMContactRecords
  },
  [CRM_OBJECT_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseCrmObject
  },
  [CORE_SEATS_STARTER]: {
    upgradeLink: links.bundle
  },
  [CORE_SEATS_PROFESSIONAL]: {
    upgradeLink: links.bundle
  },
  [CORE_SEATS_ENTERPRISE]: {
    upgradeLink: links.bundle
  },
  [MARKETING_PLUS_PROFESSIONAL]: {
    upgradeLink: links.marketingPlusPricing
  },
  [MARKETING_PLUS_ENTERPRISE]: {
    upgradeLink: links.marketingPlusPricing
  },
  [BREEZE_INTELLIGENCE_CREDITS_100]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [BREEZE_INTELLIGENCE_CREDITS_1000]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [BREEZE_INTELLIGENCE_CREDITS_10000]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_100]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_1000]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_10000]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [HUBSPOT_CREDITS_COMMITTED]: {
    upgradeLink: links.hubspotCreditsPricing
  },
  [HUBSPOT_CREDITS_COMMITTED_OVERAGE]: {
    upgradeLink: links.hubspotCreditsPricing
  },
  [HUBSPOT_CREDITS_OVERAGE]: {
    upgradeLink: links.hubspotCreditsPricing
  },
  [COMMERCE_PROFESSIONAL]: {
    upgradeLink: links.commerceHubPricing
  },
  [COMMERCE_ENTERPRISE]: {
    upgradeLink: links.commerceHubPricing
  }
};
export const UpgradeProductPropertiesFromApiName = {
  // commented out below did not have equivalent API name mappings

  // these had no Pricing Pages PageView amplitude events for the associated URL
  // [DESIGNATED_TECHNICAL_SUPPORT]: {
  //   upgradeLink: links.serviceDesignatedTechnicalSupport,
  // },
  // [WEBSITE]: { upgradeLink: links.addonWebsite },
  // [ADDITIONAL_ACCOUNT]: { upgradeLink: links.addonAdditionalPortalLink },
  // [STARTER_KIT]: { upgradeLink: links.serviceStarterKit },
  // [IN_PERSON_TRAINING]: { upgradeLink: links.serviceInPersonTraining },

  // can't determine if viewed
  // [BASIC_CONTACTS]: { upgradeLink: links.marketingPricing },
  // [STARTER_CONTACTS]: { upgradeLink: links.starterContacts },
  // [MARKETING_STARTER_CONTACTS]: { upgradeLink: links.marketingPricing },
  // [MARKETING_PROFESSIONAL_CONTACTS]: { upgradeLink: links.marketingPricing },
  // [MARKETING_ENTERPRISE_CONTACTS]: { upgradeLink: links.marketingPricing },
  // [ADS_CAPACITY]: { upgradeLink: links.addonAds },
  // [MARKETING]: { upgradeLink: links.marketingPricing },
  // [SALES]: { upgradeLink: links.salesPricing },
  // [SERVICE]: { upgradeLink: links.servicePricing },
  [BUNDLE]: {
    upgradeLink: links.bundle
  },
  [FreeProducts.SALES_HUB_FREE]: {
    upgradeLink: links.salesPricing
  },
  [Products.SALES_HUB_STARTER]: {
    upgradeLink: links.salesPricing
  },
  [Products.SALES_HUB_PROFESSIONAL]: {
    upgradeLink: links.salesPricing
  },
  [Products.SALES_HUB_ENTERPRISE]: {
    upgradeLink: links.salesPricing
  },
  [FreeProducts.MARKETING_HUB_FREE]: {
    upgradeLink: links.marketingPricing
  },
  [Products.MARKETING_HUB_STARTER]: {
    upgradeLink: links.marketingPricing
  },
  [Products.MARKETING_HUB_BASIC]: {
    upgradeLink: links.marketingPricing
  },
  [Products.MARKETING_HUB_PROFESSIONAL]: {
    upgradeLink: links.marketingPricing
  },
  [Products.MARKETING_HUB_ENTERPRISE]: {
    upgradeLink: links.marketingPricing
  },
  [FreeProducts.SERVICE_HUB_FREE]: {
    upgradeLink: links.servicePricing
  },
  [Products.SERVICE_HUB_STARTER]: {
    upgradeLink: links.servicePricing
  },
  [Products.SERVICE_HUB_PROFESSIONAL]: {
    upgradeLink: links.servicePricing
  },
  [Products.SERVICE_HUB_ENTERPRISE]: {
    upgradeLink: links.servicePricing
  },
  [Products.CMS_HUB_STARTER]: {
    upgradeLink: links.cmsPricing
  },
  [Products.CMS_HUB_PROFESSIONAL]: {
    upgradeLink: links.cmsPricing
  },
  [Products.CMS_HUB_ENTERPRISE]: {
    upgradeLink: links.cmsPricing
  },
  [Products.NON_MARKETING_CONTACTS_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseCRMContactRecords
  },
  [Products.CRM_OBJECT_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseCrmObject
  },
  [Products.OPERATIONS_HUB_STARTER]: {
    upgradeLink: links.operationsPricing
  },
  [Products.OPERATIONS_HUB_PROFESSIONAL]: {
    upgradeLink: links.operationsPricing
  },
  [Products.OPERATIONS_HUB_ENTERPRISE]: {
    upgradeLink: links.operationsPricing
  },
  [Products.ADS_LIMIT_INCREASE]: {
    upgradeLink: links.addonAds
  },
  [Products.REPORTING_LIMIT_INCREASE]: {
    upgradeLink: links.addonReporting
  },
  [Products.TECH_SERVICE_DEDICATED_IP_FOR_EMAIL]: {
    upgradeLink: links.addonDedicatedIp
  },
  [Products.TRANSACTIONAL_EMAIL]: {
    upgradeLink: links.addonTransactionalEmail
  },
  [Products.BRAND_DOMAIN]: {
    upgradeLink: links.addonBrandDomain
  },
  [Products.LISTS_LIMIT_INCREASE]: {
    upgradeLink: links.marketingPricing
  },
  [Products.ESIGNATURE_LIMIT_INCREASE]: {
    upgradeLink: links.salesPricing
  },
  [Products.DOMAINS_LIMIT_INCREASE]: {
    upgradeLink: links.marketingPricing
  },
  [Products.WEB_HOSTING_CUSTOM_SSL_PACK]: {
    upgradeLink: links.addonCustomSsl
  },
  [Products.SANDBOX_LIMIT_INCREASE]: {
    upgradeLink: links.addonSandbox
  },
  [Products.STARTER_KIT]: {
    upgradeLink: links.serviceStarterKit
  },
  [Products.SALES_HUB_PROFESSIONAL_ONBOARDING]: {
    upgradeLink: links.salesProfessionalOnboarding
  },
  [Products.SERVICE_HUB_PROFESSIONAL_ONBOARDING]: {
    upgradeLink: links.serviceProfessionalOnboarding
  },
  [Products.INBOUND_CONSULTING_ADVANCED]: {
    upgradeLink: links.inboundConsultingBlock
  },
  [Products.INBOUND_CONSULTING_PREMIUM]: {
    upgradeLink: links.inboundConsultingBlock
  },
  [Products.TECHNICAL_CONSULTING_ONGOING]: {
    upgradeLink: links.technicalConsultingBlock
  },
  [Products.TECHNICAL_CONSULTING_4_HOUR]: {
    upgradeLink: links.technicalConsultingBlock
  },
  [Products.TECHNICAL_CONSULTING_ADVANCED]: {
    upgradeLink: links.technicalConsultingBlock
  },
  [Products.TECHNICAL_CONSULTING_PREMIUM]: {
    upgradeLink: links.technicalConsultingBlock
  },
  [Products.CRM_SUITE_STARTER_BUNDLE]: {
    upgradeLink: links.suite
  },
  [Products.CRM_SUITE_PROFESSIONAL_BUNDLE]: {
    upgradeLink: links.suite
  },
  [Products.CRM_SUITE_ENTERPRISE_BUNDLE]: {
    upgradeLink: links.suite
  },
  [Products.CALLING_LIMIT_INCREASE]: {
    upgradeLink: links.addonCalling
  },
  [Products.PHONE_LIMIT_INCREASE]: {
    upgradeLink: links.addonPhone
  },
  [Products.TEAMS_LIMIT_INCREASE]: {
    upgradeLink: links.addonTeams
  },
  [Products.WHATSAPP_LIMIT_INCREASE]: {
    upgradeLink: links.addonWhatsapp
  },
  [MARKETING_SMS_ADDON]: {
    upgradeLink: links.addonMarketingSms
  },
  [MARKETING_SMS_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseMarketingSms
  },
  [Products.VIDEO_LIMIT_INCREASE]: {
    upgradeLink: links.addonVideo
  },
  [Products.WORKFLOWS_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseWorkflows
  },
  [Products.USERS_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseUsers
  },
  [Products.CUSTOM_OBJECTS_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseCustomObjects
  },
  [Products.CUSTOM_PROPERTIES_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseCustomProperties
  },
  [Products.CALCULATED_PROPERTIES_LIMIT_INCREASE]: {
    upgradeLink: links.limitIncreaseCalculatedProperties
  },
  [Products.CORE_SEATS_STARTER]: {
    upgradeLink: links.bundle
  },
  [Products.CORE_SEATS_PROFESSIONAL]: {
    upgradeLink: links.bundle
  },
  [Products.CORE_SEATS_ENTERPRISE]: {
    upgradeLink: links.bundle
  },
  [Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL]: {
    upgradeLink: links.marketingPlusPricing
  },
  [Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE]: {
    upgradeLink: links.marketingPlusPricing
  },
  [Products.BREEZE_INTELLIGENCE_CREDITS_100]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [Products.BREEZE_INTELLIGENCE_CREDITS_1000]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [Products.BREEZE_INTELLIGENCE_CREDITS_10000]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [Products.BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [Products.BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [Products.BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [Products.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_100]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [Products.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_1000]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [Products.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_10000]: {
    upgradeLink: links.breezeIntelligencePricing
  },
  [Products.HUBSPOT_CREDITS_COMMITTED]: {
    upgradeLink: links.hubspotCreditsPricing
  },
  [Products.HUBSPOT_CREDITS_COMMITTED_OVERAGE]: {
    upgradeLink: links.hubspotCreditsPricing
  },
  [Products.HUBSPOT_CREDITS_OVERAGE]: {
    upgradeLink: links.hubspotCreditsPricing
  },
  [Products.COMMERCE_HUB_PROFESSIONAL]: {
    upgradeLink: links.commerceHubPricing
  },
  [Products.COMMERCE_HUB_ENTERPRISE]: {
    upgradeLink: links.commerceHubPricing
  },
  [Products.CORE_SEATS_PROFESSIONAL_HSOC]: {
    upgradeLink: links.hsocCoreSeats
  },
  [Products.CORE_SEATS_ENTERPRISE_HSOC]: {
    upgradeLink: links.hsocCoreSeats
  },
  [Products.FRONT_OFFICE_SEATS_PROFESSIONAL]: {
    upgradeLink: links.hsocFrontOfficeSeats
  },
  [Products.FRONT_OFFICE_SEATS_ENTERPRISE]: {
    upgradeLink: links.hsocFrontOfficeSeats
  }
};
export default UpgradeProductProperties;